/* global process */
import axios from 'axios';

export const createClientProfileAuthorize = async ({ body }) => {
  return await axios.post(`${process.env.REACT_APP_API_URL}/paymentservie/createClientProfile`, body);
};
